import { useId } from 'react'

const SoilContainer = ({
  onClick,
  active = false,
  disabled = false
}) => {
  const id = useId()

  return (
    <svg
      viewBox="0 0 80 70"
      width={75}
      height={65}
      onClick={disabled ? undefined : onClick}
      style={{
        cursor: disabled ? 'default' : onClick ? 'pointer' : 'default',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.2s ease'
      }}
    >
      <defs>
        {/* Container gradient */}
        <linearGradient id={`container-${id}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#FEF3C7" />
          <stop offset="50%" stopColor="#FCD34D" />
          <stop offset="100%" stopColor="#F59E0B" />
        </linearGradient>

        {/* Soil gradient */}
        <linearGradient id={`soil-${id}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#92603A" />
          <stop offset="50%" stopColor="#6B4423" />
          <stop offset="100%" stopColor="#4A2C12" />
        </linearGradient>

        {/* Soil texture pattern */}
        <pattern id={`soil-texture-${id}`} patternUnits="userSpaceOnUse" width="10" height="10">
          <circle cx="3" cy="3" r="1.5" fill="#5D3A1A" opacity="0.5" />
          <circle cx="8" cy="7" r="1" fill="#4A2C12" opacity="0.4" />
          <circle cx="5" cy="1" r="0.8" fill="#6B4423" opacity="0.3" />
        </pattern>

        {/* Shadow */}
        <filter id={`shadow-${id}`} x="-10%" y="-10%" width="120%" height="130%">
          <feDropShadow dx="2" dy="3" stdDeviation="2" floodOpacity="0.25"/>
        </filter>
      </defs>

      {/* Active glow */}
      {active && (
        <rect
          x="3" y="3" width="74" height="50" rx="6"
          fill="none"
          stroke="var(--primary)"
          strokeWidth="2.5"
          style={{ animation: 'glow 1.5s ease-in-out infinite' }}
        />
      )}

      <g filter={`url(#shadow-${id})`}>
        {/* Container body */}
        <rect
          x="8" y="8"
          width="64" height="40"
          fill={`url(#container-${id})`}
          stroke="#D97706"
          strokeWidth="2"
          rx="5"
        />

        {/* Container rim */}
        <rect
          x="5" y="5"
          width="70" height="8"
          fill="#FBBF24"
          stroke="#D97706"
          strokeWidth="2"
          rx="3"
        />

        {/* Soil inside */}
        <rect
          x="12" y="16"
          width="56" height="28"
          fill={`url(#soil-${id})`}
          rx="3"
        />

        {/* Soil texture overlay */}
        <rect
          x="12" y="16"
          width="56" height="28"
          fill={`url(#soil-texture-${id})`}
          rx="3"
        />

        {/* Soil surface highlights */}
        <ellipse cx="25" cy="20" rx="6" ry="2.5" fill="#9A5E32" opacity="0.4" />
        <ellipse cx="50" cy="22" rx="5" ry="2" fill="#9A5E32" opacity="0.3" />
      </g>

      {/* Label - larger and clearer */}
      <text
        x="40" y="62"
        fontSize="12"
        fill="var(--text-primary)"
        textAnchor="middle"
        fontWeight="600"
      >
        Soil
      </text>
    </svg>
  )
}

export default SoilContainer
